import { render, staticRenderFns } from "./SubscriptionConfigurationEdit.vue?vue&type=template&id=67df20e9&scoped=true"
import script from "./SubscriptionConfigurationEdit.vue?vue&type=script&lang=js"
export * from "./SubscriptionConfigurationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df20e9",
  null
  
)

export default component.exports